import React, { useState } from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import { Logo_mateMATTIci } from "../assets";
// for link
import { useCallback } from "react";
import { Alert, Linking } from "react-native";

const OpenURLButton = ({ url, source_image }) => {
	const handlePress = useCallback(async () => {
		// Checking if the link is supported for links with custom URL scheme.
		const supported = await Linking.canOpenURL(url);

		if (supported) {
			// Opening the link with some app, if the URL scheme is "http" the web link should be opened
			// by some browser in the mobile
			await Linking.openURL(url);
		} else {
			Alert.alert(`Don't know how to open this URL: ${url}`);
		}
	}, [url]);
	return (
		<TouchableOpacity
			className="w-[390px] h-[220px] mr-3 mt-1 bg-[#1E272C] rounded-t-2xl"
			onPress={handlePress}
		>
			<Image
				source={source_image}
				className="w-full h-full rounded-2xl"
			/>
		</TouchableOpacity>
	);
};

function parseDate(date) {
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const day = date.getDate();
	return { year: year, month: month, day: day };
}

function getDateString({
	year,
	month,
	day,
}: {
	year: number;
	month: number;
	day: number;
}) {
	let res = "";
	res += `${day.toString()} `;
	switch (month) {
		case 1:
			res += "Gennaio";
			break;
		case 2:
			res += "Febbraio";
			break;
		case 3:
			res += "Marzo";
			break;
		case 4:
			res += "Aprile";
			break;
		case 5:
			res += "Maggio";
			break;
		case 6:
			res += "Giugno";
			break;
		case 7:
			res += "Luglio";
			break;
		case 8:
			res += "Agosto";
			break;
		case 9:
			res += "Settembre";
			break;
		case 10:
			res += "Ottobre";
			break;
		case 11:
			res += "Novembre";
			break;
		case 12:
			res += "Dicembre";
			break;
		default:
			res += "";
	}
	res += " ";
	res += year.toString();
	return res;
}

const VideoCard = ({
	videoLink,
	thumbnailLink,
	title,
	videoDate,
}: {
	videoLink: string;
	thumbnailLink: string;
	title: string;
	videoDate: string;
}) => {
	return (
		<View className="flex-column space-y-1">
			<View className="flex-1">
				{/* Copertina */}
				<OpenURLButton
					url={`${videoLink}`}
					source_image={{ uri: `${thumbnailLink}` }}
				/>
				{/* Descrizione */}
				<View className="flex-col items-start bg-[#1E272C] w-[390px] rounded-b-2xl mb-3">
					{/* <View>
						<Image
							source={Logo_mateMATTIci}
							className="w-10 h-10 rounded-full object-cover"
						/>
					</View> */}
					<View className="my-1 mx-2">
						<Text className="text-white">
							{title?.length > 50
								? `${title.slice(0, 50)}..`
								: title}
						</Text>
					</View>
					<View className="my-1 mx-2">
						<Text className="text-white">
							Pubblicato il:{" "}
							{getDateString(parseDate(new Date(videoDate)))}
						</Text>
					</View>
				</View>
			</View>
		</View>
	);
};

export default VideoCard;
